module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Dialog":{"dialog.dialogClass":[{"value":"mc-site-common-popup","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.Dialog","_fox_":1}]},"~.User_PasswordRecovery_Base":{"widgets.successPopup.dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.User_PasswordRecovery_Base","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/popup.js
// module id = 1008
// module chunks = 4